import React from 'react';
import { Sidebar, SidebarLink } from 'styleguide/src/components/Sidebar';
import { kebabCase } from 'lodash';
import { withRouter, RouteComponentProps } from 'react-router';

const PAGES = [
  'Buttons',
  'Colors',
  'Dropdowns',
  'Fields',
  'Fonts',
  'Forms',
  'Modals',
  'Tables',
  'Toggles',
  'Sorter',
  'Misc',
];

const isActive = (key: string, pathname: string) => {
  const parts = pathname.split('/');
  return parts[parts.length - 1] === key;
};

const StyleGuideSidebar = (props: RouteComponentProps) => (
  <Sidebar>
    <SidebarLink
      href="/dev/dashboard"
      dataCy="sidebar-nav-styleguide-dev-dashboard"
      iconLeft="chevron-left"
      text="Back to Dev Dashboard"
    />
    {PAGES.map((pageName) => {
      const kebabName = kebabCase(pageName);
      return (
        <SidebarLink
          key={pageName}
          active={isActive(kebabName, props.location.pathname)}
          dataCy={`sidebar-nav-styleguide-${kebabName}`}
          href={`/dev/styleguide/${kebabName}`}
          text={pageName}
        />
      );
    })}
  </Sidebar>
);

export default withRouter(StyleGuideSidebar);
